import React from "react";
import Layout from "../components/Layout";
import CostCalculationTemplate from "../pages/CostCalculation";

const CostCalculationPage = () => {
  return (
    <Layout>
      <CostCalculationTemplate />
    </Layout>
  );
};

export default CostCalculationPage;
